export const unitedParkingSystemsStyles = {
	header: {
		backgroundColor: '#273171',
	},
	sidebar: {
		backgroundColor: '#2475fc',
		color: 'black',
	},
	button: {
		backgroundColor: '#ADC44A',
		color: '#000000',
		border: '1px solid #000000',
		fontWeight: 600,
		':hover': {
			color: '#ffffff',
			backgroundColor: '#133075',
		},
	},
	title: {
		color: 'white',
	},
	text: {
		color: '#000000',
	},
	table: {
		headerBackgroundColor: '#133075',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'United Parking Services Platform',
	},
	logo: {
		small: {
			src: '/unitedParkingSystems/united-parking-systems-icon-small.png',
			height: 45,
			width: 45,
		},
		large: {
			src: '/unitedParkingSystems/united-parking-systems-new-logo.svg',
			height: 55,
			width: 120,
		},
	},
	favicon: {
		src: '/unitedParkingSystems/united-parking-systems-icon-small.png',
	},
	socials: {
		facebook: 'https://www.facebook.com/profile.php?id=61587822457914',
		linkedIn: 'https://www.linkedin.com/company/united-parking-systems/',
		x: 'https://x.com/ParkingUni90405',
	},
	siteUrl: 'https://unitedparkingsystem.com/',
	orgName: 'United Parking Systems',
};
